/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Summary } from '../App.style';

export default () => (
  <>
    <Summary>
      I'm reaching out to apply for your Senior Frontend Engineer position in
      Amsterdam. I'm currently a Senior Full Stack Developer at Elsevier. Prior
      to that, I was the Lead Mobile Application Developer at Prodigy Education
      in Toronto and have over 10 years of full stack development experience
      throughout my career.
    </Summary>
    <br />
    <Summary>
      Prodigy and Elsevier are both companies with millions of active users,
      working with both companies gave me the opportunity to develop impactful,
      scalable solutions in collaboration with multiple stakeholders. I like to
      approach problems holistically and pragmatically, solving real issues and
      not just their symptoms. I have experience eliminating technical debt,
      owning large features, cleaning architectural inefficiencies, and team
      management.
    </Summary>
    <br />
    <Summary>
      I recently started using Miro on a personal project, where a friend is
      working on the product design right along side my Kanban board.
      Experiencing both interfaces together in one view has been really useful
      and a lot of fun to use. I am looking for a role where I can use my
      experience with multifunctional teams in addition to having an impact on
      development life-cycle. I want to work on a team where I can continue to
      grow as a professional while being passionate and proud of what I'm
      building.
    </Summary>
    <br />
    <Summary>
      After using the product and reading through the job expectations, I feel
      like Miro could be a really great fit. Thanks for taking the time to learn
      more about me, I truly hope I've given you enough reasons for more
      consideration. I hope to hear from you soon!
    </Summary>
    <br />
  </>
);
